import useStyles from "../styles";

// --| CardCount takes 3 props title, icon and count
const CardCount = ({ title, icon, count }) => {
  const classes = useStyles();

  return (
    <div className={classes.overallcont}>
      <div className={classes.cardcount}>
        <div className={classes.left}>
          <h6 className={classes.cardtitle}>{title}</h6>
          <p className={classes.count}>{count}</p>
        </div>
        <div className={classes.icon}>{icon}</div>
      </div>
      <hr />
    </div>
  );
};

export default CardCount;
